import { render, staticRenderFns } from "./wasteproductionAddView.vue?vue&type=template&id=12d07b60&scoped=true&"
import script from "./wasteproductionAddView.vue?vue&type=script&lang=js&"
export * from "./wasteproductionAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d07b60",
  null
  
)

export default component.exports